import { mutationNames } from '@/store/storeKeysettings'

const state = {
  YoutubeData: {
    'Id': 0,
    'PageTitle': '',
    'RowCreated': null,
    'RowUpdated': null,
    'SubscriptionModule_Id': 0,
    'YouTubeAPIKey': null,
    'YouTubeChannel': null
  }
}

const mutations = {
  [mutationNames.SET_YOUTUBEDATA](state, data) {
    state.YoutubeData = data
  },
  [mutationNames.UPDATE_YOUTUBE](state, data) {
    state.YoutubeData = data
  }
}

const actions = {
  initYoutubeData: ({ commit }) => {
    commit(mutationNames.SET_YOUTUBEDATA)
  }
}

const getters = {
  Youtube: state => {
    return state.YoutubeData
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}


// WEBPACK FOOTER //
// ./src/store/modules/youtube.js